import React from 'react';
import { Popup, Icon, List, ListItem } from 'semantic-ui-react';

import * as S from './styles';
import { ProductFormProps } from '../../../PortoEssencialHire/ModalHireProposal';
import { InsurersCodeEnum } from '../../../../../../../../enums/insurers-code.enum';
import OfferCard, { OfferCardList } from '../../../HireSummary/OfferCard';
import { normalizeOffer } from '../../../HireSummary/hireValues';

export type CardsSelectOffersProps = {
  insurerCode: string | undefined;
  offers: ProductFormProps[];
  selected: any;
  setSelected: (selected: any) => void;
};

const Porto20Details = () => {
  return (
    <div style={{ margin: '4px' }}>
      <S.Table>
        <tr>
          <th>Coberturas</th>
          <th>Limite Máximo de Idênização</th>
        </tr>
        <tr>
          <td>Aluguel</td>
          <td>Até 20x a verba coberta</td>
        </tr>
        <tr>
          <td>IPTU, condomínio, água, Luz e Gás</td>
          <td>Até 20x a verba coberta</td>
        </tr>
        <tr>
          <td>Danos ao imóvel</td>
          <td>Até 6 alugueis</td>
        </tr>
        <tr>
          <td>Multa por Recisão contratual </td>
          <td>Até 3 alugueis</td>
        </tr>
        <tr>
          <td>Pintura interna e externa</td>
          <td>Até 2 alugueis</td>
        </tr>
      </S.Table>
    </div>
  )
};

const Porto30Details = () => {
  return (
    <div style={{ margin: 4 }}>
      <S.Table>
        <tr>
          <th>Coberturas</th>
          <th>Limite Máximo de Idênização</th>
        </tr>
        <tr>
          <td>Aluguel</td>
          <td>Até 30x a verba coberta</td>
        </tr>
        <tr>
          <td>IPTU, condomínio, água, Luz e Gás</td>
          <td>Até 30x a verba coberta</td>
        </tr>
        <tr>
          <td>Danos ao imóvel</td>
          <td>Até 6 alugueis</td>
        </tr>
        <tr>
          <td>Multa por Recisão contratual</td>
          <td>Até 3 alugueis</td>
        </tr>
        <tr>
          <td>Pintura interna e externa</td>
          <td>Até 3 alugueis</td>
        </tr>
      </S.Table>
    </div>
  );
};

const GaranttiDetails = (lmi: string) => {
  return (
    <div style={{ margin: 4 }}>
      {`LMI de ${lmi}x o aluguel para utilizar:`}
      <List bulleted>
        <ListItem>Aluguel</ListItem>
        <ListItem>Condomínio</ListItem>
        <ListItem>IPTU</ListItem>
        <ListItem>Água</ListItem>
        <ListItem>Luz</ListItem>
      </List>

      <p style={{ fontSize: '12px', width: '300px', textAlign: 'justify' }}>
        Multa rescisória (limitado a 3 vezes o valor do aluguel proporcional ao período restante do contrato)
        Valor final da locação PINTURA e DANOS AO IMÓVEL (limitado a 6 vezes o valor do aluguel, podendo utilizar
        até 3 vezes para pintura e o restante em Danos)
      </p>
    </div>
  )
};

const SelectInfo = (insurerCode: string, offer: any) => {
  let infoSelected = null;

  switch (insurerCode) {
    case InsurersCodeEnum.Garantti:
      infoSelected = GaranttiDetails(offer.lmi);
      break;
    case InsurersCodeEnum.PortoEssencial:
      if (offer.nomeSeguro === 'ESSENCIAL 20')
        infoSelected = Porto20Details();
      if (offer.nomeSeguro === 'ESSENCIAL 30')
        infoSelected = Porto30Details();
      break;
    default:
      return null;
  }

  return (
    <Popup
      style={{ overflow: 'visible', position: 'absolute' }}
      flowing
      hoverable
      position='left center'
      disabled={infoSelected === null}
      trigger={
        <Icon
          name={'info circle'}
          color={'blue'}
          disabled={infoSelected === null}
          style={{ cursor: 'help', marginTop: 2 }}
        />
      }
    >
      { infoSelected }
    </Popup>
  );
};

export const CardsSelectOffers = ({ insurerCode, offers, selected, setSelected }: CardsSelectOffersProps) => (
  <OfferCardList>
    {offers &&
      offers.map((offer, i) => (
        <OfferCard
          key={i}
          name="general-offer"
          offer={normalizeOffer(offer)}
          selected={selected?.nomeSeguro === offer.nomeSeguro}
          onSelect={() => setSelected(offer)}
          info={insurerCode && SelectInfo(insurerCode, offer)}
        />
      ))}
  </OfferCardList>
);
export default CardsSelectOffers;
